'use client';
import { useQuery } from '@tanstack/react-query';
import { getLiveTransmission } from '@pulsex/services';
export default function useLiveTransmission(config) {
    const query = useQuery({
        queryKey: ['GET_LIVE_TRANSMISSION'],
        queryFn: () => getLiveTransmission(config),
        refetchOnWindowFocus: false,
    });
    if (query.isError) {
        console.error('Query Error:', query.error);
    }
    return {
        isLoading: query.isLoading,
        data: query.data,
    };
}
